import { MultiPolygon, Polygon } from "geojson";
import { computed } from "mobx";
import { useMemo } from "react";
import { useDrawMapStore } from "..";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";
import { DrawMapMode } from "../store/DrawMapStore";

export default function (): Shape[] | null {
    const drawMapStore = useDrawMapStore();
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => computed(() => drawMapStore.mode === DrawMapMode.Insights
        ? drawMapStore.result && geometryService.mapGeometryToShapes(drawMapStore.result.features[0].geometry as Polygon | MultiPolygon)
        : null), []).get();
}